import {EntityModel} from "@/shared/model";
import {Context} from "@/shared/context";

export class ProjectCategoryModel extends EntityModel {
    public readonly slug: string
    public readonly name: string
    public readonly description: string
    public readonly projectCount: number

    constructor(ctx: Context, data: any) {
        super(ctx, data)
        this.slug = this.getString('slug')
        this.name = this.getString('name')
        this.description = this.getString('description')
        this.projectCount = this.getNumber('project_count')
    }
}